"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabNav = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _TabContext = require("./TabContext");
var _styles = require("./styles");
var _useContainerDimensions = require("./utils/useContainerDimensions");
var _Select = _interopRequireWildcard(require("../Select"));
var _Link = _interopRequireDefault(require("../Link"));
var _useIsMobile = require("../../hooks/useIsMobile");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const TabNav = ({
  value,
  children,
  onChange,
  css,
  maxWidth,
  color,
  underlineColor,
  vertical,
  actions,
  className,
  breakpoint
}) => {
  const isMobile = (0, _useIsMobile.useIsMobile)(breakpoint);
  const theme = (0, _react2.useTheme)();

  // Container dimensions
  const ref = _react.default.useRef(null);
  const {
    width: containerWidth
  } = (0, _useContainerDimensions.useContainerDimensions)(ref);

  // Button dimensions
  const buttonRef = _react.default.useRef(null);
  const {
    width: actionsWidth
  } = (0, _useContainerDimensions.useContainerDimensions)(buttonRef);
  const values = _react.default.Children.map(children, child => child !== null && child.props)?.filter(Boolean) || [];
  const displayNameFromValue = value => {
    const item = values.find(item => item.value === value);
    return item?.displayText || String(value);
  };
  const valueWithSelectItemIndex = values.findIndex(item => item.selectItems?.length);
  const listOfSelectedItems = items => {
    if (!items) return [];
    return items.map(prop => ({
      ...prop
    }));
  };
  if (valueWithSelectItemIndex > -1) {
    const selectedItems = values[valueWithSelectItemIndex].selectItems;

    // If we have no actual selectedItems, dont show any label while in the mobile/dropdown version
    const isEverySelectedItemDisabledOrLink = Number(selectedItems?.length) >= 1 && selectedItems?.every(item => item.disabled || item.onClick);
    if (isEverySelectedItemDisabledOrLink) {
      const itemsWithOnClick = selectedItems?.filter(item => item.onClick) || [];

      // Remove valueWithSelectItemIndex from the values array, but add on itemsWithOnClick in the list
      values.splice(valueWithSelectItemIndex, 1, ...listOfSelectedItems(itemsWithOnClick));
    } else {
      values.splice(valueWithSelectItemIndex + 1, 0, ...listOfSelectedItems(selectedItems));
    }
  }
  return (0, _jsxRuntime.jsx)(_TabContext.TabContextProvider, {
    onChange: onChange,
    value: value || values?.[0].value,
    children: (0, _jsxRuntime.jsx)(_TabContext.TabContext.Consumer, {
      children: ({
        width: childrenTotalWidth,
        setActive,
        active
      }) => {
        if (breakpoint && isMobile || !breakpoint && actionsWidth + childrenTotalWidth > containerWidth) {
          // Render dropdown instead of tabs

          return (0, _jsxRuntime.jsxs)(_styles.SelectWrapper, {
            children: [(0, _jsxRuntime.jsx)(_Select.default, {
              input: true,
              width: "auto",
              text: "Velg",
              selectedValue: displayNameFromValue(String(active)) || '0',
              onChange: ({
                value
              }) => value && setActive(value),
              className: className,
              maxHeight: "40vh",
              children: values.map(({
                displayText,
                value: v,
                selectItems,
                onClick,
                indent,
                disabled
              }) => onClick ? (0, _jsxRuntime.jsx)(_styles.SelectLinkWrapper, {
                children: (0, _jsxRuntime.jsx)(_Link.default, {
                  nopadding: true,
                  small: true,
                  onClick: onClick,
                  children: displayText || v
                })
              }, v) : (0, _jsxRuntime.jsx)(_Select.Option, {
                value: v,
                indent: indent,
                disabled: disabled || Boolean(selectItems?.length),
                children: displayText || v
              }, v))
            }), actions]
          });
        }
        return (0, _jsxRuntime.jsxs)(_styles.TabNavWrapper, {
          ref: ref,
          theme: theme,
          className: className,
          css: () => [vertical && _styles.styles.vertical, color && _styles.styles.color(color), maxWidth && _styles.styles.maxWidth(maxWidth), underlineColor && _styles.styles.underlineColor(underlineColor), css],
          children: [children, actions && (0, _jsxRuntime.jsx)(_styles.TabNavActions, {
            ref: buttonRef,
            children: actions
          })]
        });
      }
    })
  });
};
exports.TabNav = TabNav;
var _default = exports.default = TabNav;